import { render, staticRenderFns } from "./OptionOptItems.vue?vue&type=template&id=e327eb18&"
import script from "./OptionOptItems.vue?vue&type=script&lang=js&"
export * from "./OptionOptItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports